@if (type=='form') {
<div class="container mt-3">
  <div class="row">
    <div class="col-12 mb-3">
      <p-skeleton [width]="'100%'" [height]="'40px'"></p-skeleton>
    </div>
    <div class="col-12 mb-3">
      <p-skeleton [width]="'100%'" [height]="'40px'"></p-skeleton>
    </div>
    <div class="col-12 mb-3">
      <p-skeleton [width]="'100%'" [height]="'40px'"></p-skeleton>
    </div>
    <div class="col-12 mb-3">
      <p-skeleton [width]="'100%'" [height]="'40px'"></p-skeleton>
    </div>
    <div class="col-12 mb-3">
      <p-skeleton [width]="'100%'" [height]="'40px'"></p-skeleton>
    </div>
    <div class="col-12 mb-3">
      <p-skeleton [width]="'100%'" [height]="'40px'"></p-skeleton>
    </div>
    <div class="col-12">
      <p-skeleton [width]="'100%'" [height]="'40px'"></p-skeleton>
    </div>
  </div>
</div>
}